import { FC } from "react";

import Stack from "@mui/material/Stack";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormIcon } from "@/forms-design-system/FormIcon";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { Lock } from "@/icons/outlined";

export const AuctionRateClosedInfo: FC = () => {
  const { t } = useTranslate();

  return (
    <Stack direction="row" gap={0.5} alignItems="center">
      <FormIcon size="small" sx={(theme) => ({ color: theme.palette.forms?.text.moderate })}>
        <Lock />
      </FormIcon>
      <FormTypography variant="body2" vibe="moderate">
        {t("ticketing", "auctionV2.antiSniping.rateClosed")}
      </FormTypography>
    </Stack>
  );
};
